exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  JQUERY UI */\n.ui-sortable-placeholder {\n    border-color: #f2f4f8 !important;\n    visibility: visible !important;\n    background-size: 30px 30px;\n    background-image: linear-gradient(-45deg, #f2f4f8 25%, transparent 25%, transparent 50%, #f2f4f8 50%, #f2f4f8 75%, transparent 75%, transparent);\n    animation: ui-placeholder-stripes 2s linear infinite;\n}\n\n@keyframes ui-placeholder-stripes {\n    from {\n        background-position: 0 0;\n    }\n    to {\n        background-position: 60px 30px;\n    }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/node_modules/postcss-loader?{"ident":"postcss"}!F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/assets/modules/vendors/jquery-ui/jquery-ui.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/modules/vendors/jquery-ui/jquery-ui.css
// module chunks = styles